module.exports = __webpack_public_path__ + "static/media/education.eccd7b97.png";